module.exports = __webpack_public_path__ + "img/RECUADRO_Acompañamiento.e94db20b.png";